import React from "react";
import {
  TextAndImageBase,
  Text,
  Badge,
  Image,
  TextTitle,
  TextBlock,
  BulletPoint,
  BulletPoints,
  Checkmark,
} from "./text-and-image.styled";
import { TextAndImageSliceFragment } from "../../types/graphql";
import { PrismicRichText, SliceComponentProps } from "@prismicio/react";
import { htmlSerializer } from "../../utils/htmlSerializer";
import { Slice } from "@prismicio/types";
import { IPageContext } from "../../types/types";
import { SharedSliceType } from "../shared-slice/shared-slice";
import * as FA from "../../styles/fontawesome";

export type ITextAndImageProps = Slice<
  SharedSliceType.text_and_image,
  TextAndImageSliceFragment["primary"],
  TextAndImageSliceFragment["items"][number]
> & { type: SharedSliceType };

const TextAndImage = ({
  slice,
  context,
}: SliceComponentProps<ITextAndImageProps, IPageContext>) => {
  var textAndImage = slice.primary;
  const imageAsTitleIcon = textAndImage.use_image_as_title_icon;
  let bullets = slice.items;

  const ImageComponent = () =>
    (textAndImage.image?.url && (
      <Image
        alignment={slice.slice_label}
        loading="lazy"
        src={textAndImage.image.url || ""}
        alt={textAndImage.image.alt || "Xometry Image"}
      />
    )) || <></>;

  return textAndImage ? (
    <TextAndImageBase
      alignment={slice.slice_label}
      imageAsIcon={textAndImage.use_image_as_title_icon}
    >
      <Text
        alignment={slice.slice_label}
        imageAsIcon={textAndImage.use_image_as_title_icon}
      >
        {textAndImage.display_new_badge && <Badge>New!</Badge>}
        {textAndImage.title && (
          <TextTitle>
            {textAndImage.use_image_as_title_icon && <ImageComponent />}
            {textAndImage.title}
          </TextTitle>
        )}
        {textAndImage.text && (
          <TextBlock>
            <PrismicRichText
              field={textAndImage.text.richText}
              components={htmlSerializer}
            />
          </TextBlock>
        )}
        {bullets && bullets.length > 0 && (
          <BulletPoints css={FA.BulletedList}>
            {bullets.map((bullet, index) => {
              return (
                bullet &&
                bullet.bullet_point && (
                  <BulletPoint key={index}>
                    <>
                      <Checkmark css={[FA.ListBullet, FA.CheckRegular]} />
                      {bullet.bullet_point}
                    </>
                  </BulletPoint>
                )
              );
            })}
          </BulletPoints>
        )}
      </Text>
      {!textAndImage.use_image_as_title_icon && <ImageComponent />}
    </TextAndImageBase>
  ) : (
    <></>
  );
};

export default TextAndImage;
